import { render, staticRenderFns } from "./RecoverPasswordPage.vue?vue&type=template&id=b724d134&scoped=true&"
import script from "./RecoverPasswordPage.vue?vue&type=script&lang=js&"
export * from "./RecoverPasswordPage.vue?vue&type=script&lang=js&"
import style0 from "./RecoverPasswordPage.vue?vue&type=style&index=0&id=b724d134&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b724d134",
  null
  
)

export default component.exports